const PLACEHOLDER = /^(n\/?a|n\\a|na|none|none provided|no|unknown|unk|unkn|pending|pndng|tbd|tba|to be determined|binder|requested|self ?insured.*|not provided|not available|null|undefined|missing|\?|-+)\W*$/i;
const PHONE = [/^\(\d{3}\)\s?\d{3}[\s.-]\d{4}$/, /^\d{3}\.\d{3}\.\d{4}$/, /^[2-9]\d{2}-[2-9]\d{2}-\d{4}$/];
const DATE = [/^\d{1,2}[/.-]\d{1,2}[/.-](\d{2}|\d{4})$/, /^\d{4}-\d{2}-\d{2}$/];
const RUNS = ['01234567890123456789', '98765432109876543210'];
const LOOK = { O: '0', I: '1', S: '5', B: '8' };
export const WRONG_REASONS = ['placeholder', 'phone', 'date', 'too_short', 'too_long', 'no_digit', 'repeated', 'sequence', 'claim_number',
    'other_record', 'vin', 'other_carrier', 'not_insurance_document'];
/** why our files' number is not used, as a person reads it (the Found-a-number row's "Not used" line) */
export const WRONG_WORDS = Object.freeze({
    placeholder: 'a placeholder, not a number', phone: 'a phone number', date: 'a date', too_short: 'too short to be a policy number',
    too_long: 'too long to be a policy number', no_digit: 'it has no digit', repeated: 'one character repeated', sequence: 'a run of digits',
    claim_number: 'a claim number on this case', other_record: "another insurance record's policy on this case", vin: 'a VIN on this case',
    other_carrier: 'it is from another carrier', not_insurance_document: 'it is not from an insurance card or policy',
});
export function matchNorm(raw) {
    if (raw === null || raw === undefined)
        return null;
    const s = String(raw).toUpperCase().replace(/[^A-Z0-9]/g, '');
    return s || null;
}
const fold = (n) => n.replace(/[OISB]/g, (c) => LOOK[c]);
export function wrongReason(raw, ctx) {
    const s = raw === null || raw === undefined ? '' : String(raw).trim();
    if (!s || PLACEHOLDER.test(s))
        return 'placeholder';
    const n = matchNorm(s);
    if (!n)
        return 'placeholder';
    if (PHONE.some((re) => re.test(s)))
        return 'phone';
    if (DATE.some((re) => re.test(s)))
        return 'date';
    if (n.length < 5)
        return 'too_short';
    if (n.length > 30)
        return 'too_long';
    if (!/\d/.test(n))
        return 'no_digit';
    if (/^(.)\1*$/.test(n))
        return 'repeated';
    if (/^\d+$/.test(n) && RUNS.some((r) => r.includes(n)))
        return 'sequence';
    const c = ctx || {};
    if (c.claimKeys && c.claimKeys.has(n))
        return 'claim_number';
    if (c.otherPolicies && c.otherPolicies.has(n))
        return 'other_record';
    if (c.vins && c.vins.has(n))
        return 'vin';
    if (c.otherCarrier === true)
        return 'other_carrier';
    if (c.notInsurance === true)
        return 'not_insurance_document';
    return null;
}
export function nearOf(a, b) {
    if (!a || !b || a === b || a.length !== b.length)
        return null;
    if (fold(a) === fold(b))
        return 'look_alike';
    let d = 0;
    for (let i = 0; i < a.length; i += 1)
        if (a[i] !== b[i])
            d += 1;
    return d === 1 ? 'one_char' : null;
}
export function classifyPolicy(candidate, recordPolicy, ctx) {
    const n = matchNorm(candidate);
    const wrong = wrongReason(candidate, ctx);
    if (wrong)
        return { verdict: 'wrong', reason: wrong, norm: n };
    const r = wrongReason(recordPolicy, null) ? null : matchNorm(recordPolicy);
    if (!r)
        return { verdict: 'blank', reason: 'record_blank', norm: n };
    if (n === r)
        return { verdict: 'exact', reason: 'same', norm: n };
    const near = nearOf(n, r);
    if (near)
        return { verdict: 'near', reason: near, norm: n };
    return { verdict: 'different', reason: 'differs', norm: n };
}
export function nearAutoFix(origins) {
    const o = new Set((origins || []).filter(Boolean));
    return o.has('dec_page') || o.size >= 2;
}
//# sourceMappingURL=policy_match.js.map